require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./formations-non-certifiantes-2-4-2.json") })
        }
      }, "path---formations-non-certifiantes-2-4-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---formations-non-certifiantes-2-4-2!./.cache/json/formations-non-certifiantes-2-4-2.json
// module id = 440
// module chunks = 231608221292675